module.exports = __webpack_public_path__ + "img/ramen.0b15c280.png";